import { Component, h, Host, Prop } from '@stencil/core'

import { ProgressLine } from '../../onboarding/ui'
import { GoogleAuthButton, MicrosoftAuthButton } from '../../sign_in/ui'
import { TermsFooter } from '../../ui/components'

@Component({
  tag: 'page-signup',
})
export class PageSignup {
  @Prop() googleUrl: string
  @Prop() microsoftUrl: string
  @Prop() fromGoogle = false
  @Prop() fromMicrosoft = false
  @Prop() showMissingScopesError = false
  @Prop() showOopsError = false
  @Prop() showUnavailableCalendarError = false
  @Prop() showCalendarNotFoundError = false
  @Prop() signupProgressPercent: number

  render() {
    return (
      <Host class='flex overflow-auto flex-col items-center w-full h-screen text-base'>
        <ProgressLine percent={this.signupProgressPercent} />
        <ui-logo class='flex-grow py-10' size='xl' />

        <div class='flex flex-col flex-grow items-center'>
          <h1 class='mt-3 max-w-xl text-4xlarge leading-40px text-center text-glyph-base spacing-y-0'>
            <span class='font-extrabold'>Welcome to Fathom, let's get you set up!</span>
            <br />
            <span class='font-semibold'>This should only take 2-3 minutes 🚀</span>
          </h1>
          <div class='my-8 w-full max-w-300px spacing-y-3'>
            <GoogleAuthButton
              authUrl={this.googleUrl}
              label='Sign in with Google'
              fromGoogle={this.fromGoogle}
              showCalendarNotFoundError={this.showCalendarNotFoundError}
              showMissingScopesError={this.showMissingScopesError}
              showOopsError={this.showOopsError}
              showUnavailableCalendarError={this.showUnavailableCalendarError}
            />
            <MicrosoftAuthButton
              authUrl={this.microsoftUrl}
              label='Sign in with Microsoft'
              fromMicrosoft={this.fromMicrosoft}
              showCalendarNotFoundError={this.showCalendarNotFoundError}
              showMissingScopesError={this.showMissingScopesError}
              showOopsError={this.showOopsError}
              showUnavailableCalendarError={this.showUnavailableCalendarError}
            />
          </div>

          <TermsFooter />
        </div>
      </Host>
    )
  }
}
